import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4802c01c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4802c01c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4802c01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4802c01c')) {
      api.createRecord('4802c01c', component.options)
    } else {
      api.reload('4802c01c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4802c01c&scoped=true", function () {
      api.rerender('4802c01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserWatermark/index.vue"
export default component.exports